import { createSelector } from '@reduxjs/toolkit';
import moment from 'moment';
import { selectDateRange } from 'app/pages/Home/slice/selectors';
import { RootState } from 'types/RootState';
import { generateMonthsInRange } from '../utils/generateMonthsInRange';
import { initialState } from './monthlyTimelineSlice';

const selectSlice = (state: RootState) => state.monthlyTimeline || initialState;

export const selectMonthlyTimeline = createSelector(
  [selectSlice],
  monthlyTimelineState => monthlyTimelineState
);

export const selectTimelineViewMode = createSelector(
  [selectSlice],
  monthlyTimelineState => monthlyTimelineState.timelineViewMode
);

export const selectExpandedMonths = createSelector(
  [selectSlice],
  monthlyTimelineState => monthlyTimelineState.expandedMonths
);

export const selectTimelineIconsVisible = createSelector(
  [selectSlice],
  monthlyTimelineState => monthlyTimelineState.timelineIconsVisible
);

export const selectItemExpandVersion = createSelector(
  [selectSlice],
  monthlyTimelineState => monthlyTimelineState.itemExpandVersion
);

export const selectMonthsInRange = createSelector(
  [selectDateRange],
  dateRange => {
    if (dateRange?.start && dateRange?.end) {
      return generateMonthsInRange({
        start: dateRange.start,
        end: dateRange.end
      });
    }

    return generateMonthsInRange({
      start: moment().format('YYYY-MM-DD'),
      end: moment().add(6, 'months').format('YYYY-MM-DD')
    });
  }
);

export const selectIsMonthExpanded = createSelector(
  [selectExpandedMonths, (_state: RootState, monthKey: string) => monthKey],
  (expandedMonths, monthKey) => expandedMonths.includes(monthKey)
);
